export default __webpack_public_path__ + "static/media/logo-bca.a195a983.jpg";